import { StatusBadge } from '../Moonstar/StatusBadge';

const percentFormat = new Intl.NumberFormat(undefined, {
  style: 'percent',
  maximumFractionDigits: 0,
}).format;

export function ChecklistPercentageField({
  value,
}: {
  value: number | null | undefined;
}) {
  const normalized = normalizeChecklistPercentage(value);

  if (normalized === undefined) {
    return '—';
  }

  return (
    <StatusBadge
      level={
        normalized >= 0.8 ? 'success' : normalized >= 0.4 ? 'warning' : 'danger'
      }
    >
      {percentFormat(normalized)}
    </StatusBadge>
  );
}

export function normalizeChecklistPercentage(value: number | null | undefined) {
  if (value === undefined || value === null || Number.isNaN(value)) {
    return undefined;
  }

  if (value > 1 && value <= 100) {
    return value / 100;
  }

  return value;
}
